export const DecimalNumber = {
  print: ({ node }) => node.value
};
